/* receipt/reducer */
import { createReducer } from 'typesafe-actions';
import { ReceiptActionTypes, ReceiptState } from './types';
import {
  fetchError, fetchRequest, fetchSuccess,
  deleteError, deleteRequest, deleteSuccess, saveError, saveRequest, saveSuccess
} from './actions';

export const initialState: ReceiptState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<ReceiptState, ActionType>(initialState)
  .handleType(ReceiptActionTypes.FETCH, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(ReceiptActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(ReceiptActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload
    };
  })
  .handleType(ReceiptActionTypes.SAVE_REQUEST, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(ReceiptActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(ReceiptActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      // data: undefined
    };
  })
  .handleType(ReceiptActionTypes.DELETE_REQUEST, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(ReceiptActionTypes.DELETE_SUCCESS, state => {
    return {
      ...state,
      loading: false,
      errors: undefined
    };
  })
  .handleType(ReceiptActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload
    };
  });
